import { useEffect, useState } from "react";

import useCheckboxes from "../../hooks/useCheckboxes";
import { DISPATCH_TYPES } from "../../utils/constants";
import { dateToRegularFormat } from "../../utils/dates";
import {
  extractDamVolanteStatus,
  statusesToVerifyDam,
} from "../BillingScreen/BillingScreen";
import DamStatusSidebar from "../DamStatusSidebar/DamStatusSidebar";
import Volantes from "../Volantes/Volantes";
import { DamContainer, DamRow, StatusDiv } from "./DamStyles";

function Dam(props) {
  const {
    dni,
    loadDateWithdrawal,
    dam,
    updateSelectedVolantes,
    dateRucHook,
    onChangeVolantesForInvoice,
    refreshBilling,
  } = props;

  const {
    id,
    consigneeName,
    senasaStatus,
    electronicMandateStatus,
    entryDate,
    paidVolantes,
    volantes,
    dispatchTypeCode,
  } = dam;
  const prefixDamId = id.slice(0, id.lastIndexOf("-") + 1);
  const suffixDamId = id.slice(id.lastIndexOf("-") + 1);

  const senasaHook = useState(senasaStatus);
  const [senasa] = senasaHook;

  const electronicMandateHook = useState(electronicMandateStatus);
  const [electronicMandate] = electronicMandateHook;

  const [damStatus, setDamStatus] = useState(dam.status);

  useEffect(() => {
    const newDam = {
      ...dam,
      senasa_status: senasa,
      electronic_mandate_status: electronicMandate,
    };
    const status = extractDamVolanteStatus(newDam, statusesToVerifyDam);
    setDamStatus(status);
  }, [senasa, electronicMandate, dam]);

  const volantesHook = useState(volantes || []);
  const [damVolantes] = volantesHook;
  const [, updateDateRucStatus] = dateRucHook;

  const [checkboxesState, mainCheckboxOnChange, secondaryCheckboxOnChange] =
    useCheckboxes(damVolantes, (volante) => {
      const restrictions =
        damStatus.problems.length + volante.status2.problems.length;
      let checkboxDisable = false;
      if (volante.payment_status.option === "unquoted") {
        if (restrictions > 0) {
          checkboxDisable = true;
        } else {
          if (
            [
              dam.electronic_mandate_status.option,
              dam.senasa_status.option,
              volante.third_party_billing_authorization_status.option,
            ].includes("reviewing")
          ) {
            checkboxDisable = true;
          } else {
            checkboxDisable = false;
          }
        }
      } else {
        checkboxDisable = true;
      }
      return checkboxDisable;
    });

  // TODO: Add comment on what we are doing here.
  useEffect(() => {
    const dateRuc = {};
    for (const volante of damVolantes) {
      dateRuc[volante.id] = {
        amount: null,
        withdrawalDate: null,
        billableRuc: null,
      };
    }
    updateDateRucStatus(dateRuc);
  }, [damVolantes, updateDateRucStatus]);

  useEffect(() => {
    const list = [];
    const itemsStatus = checkboxesState.itemsStatus;
    for (const id in itemsStatus) {
      if (itemsStatus[id].checked) {
        list.push(itemsStatus[id].element);
      }
    }
    updateSelectedVolantes(list);
  }, [checkboxesState, updateSelectedVolantes]);

  const dispatchType = DISPATCH_TYPES[dispatchTypeCode];

  return (
    <>
      <DamContainer>
        <DamRow>
          <div className="main-info">
            <div className="dam-id--container">
              <span>{prefixDamId}</span>
              {suffixDamId}
            </div>
            <div className="consignee-name">{consigneeName}</div>
          </div>
          <StatusDiv status={dispatchType.category}>
            <span>{dispatchType.label.toUpperCase()}</span>
          </StatusDiv>
          <DamStatusSidebar
            dam={dam}
            status={damStatus}
            senasaHook={senasaHook}
            electronicMandateHook={electronicMandateHook}
            refreshBilling={refreshBilling}
          />
          <div>{dateToRegularFormat(entryDate)}</div>
          <div>{paidVolantes}</div>
        </DamRow>

        <div>
          <Volantes
            damStatus={damStatus}
            dni={dni}
            loadDateWithdrawal={loadDateWithdrawal}
            volantesHook={volantesHook}
            mainCheckboxOnChange={mainCheckboxOnChange}
            checkboxesState={checkboxesState}
            secondaryCheckboxOnChange={secondaryCheckboxOnChange}
            dateRucHook={dateRucHook}
            enableCheckbox={true}
            onChangeVolantesForInvoice={onChangeVolantesForInvoice}
            refreshBilling={refreshBilling}
          />
        </div>
      </DamContainer>
    </>
  );
}

export default Dam;
